import React from 'react';
import { Route, Routes } from 'react-router-dom';

// Main Finnish pages
import Index from '@/pages/Index';
import KilpailutaPage from '@/pages/KilpailutaPage';
import AxoHakemusPage from '@/pages/AxoHakemusPage';
import LainatuotteetPage from '@/pages/LainatuotteetPage';
import MeistaPage from '@/pages/MeistaPage';
import YhteydenottoPage from '@/pages/YhteydenottoPage';
import UKKPage from '@/pages/UKKPage';
import SivustokarttaPage from '@/pages/SivustokarttaPage';
import ThankYouPage from '@/pages/ThankYouPage';

// Loan product pages
import { Navigate } from 'react-router-dom';
import LainaLaskuriPage from '@/pages/lainat/UlosottolaskuriPage';
import LainavertailuPage from '@/pages/lainat/LainavertailuPage';
import SortterPage from '@/pages/SortterPage';
import UnsubscribePage from '@/pages/UnsubscribePage';
import YhdistelylainaPage from '@/pages/lainat/YhdistelylainaPage';
import AsuntolainaPage from '@/pages/lainat/AsuntolainaPage';
import AutolainaPage from '@/pages/lainat/AutolainaPage';
import CaravanrahoitusPage from '@/pages/lainat/CaravanrahoitusPage';
import HaalainaPage from '@/pages/lainat/HaalainaPage';
import JoustoluottoPage from '@/pages/lainat/JoustoluottoPage';
import KulutusluottoPage from '@/pages/lainat/KulutusluottoPage';
import LomalainaPage from '@/pages/lainat/LomalainaPage';
import MokkilainaPage from '@/pages/lainat/MokkilainaPage';
import MoottoripyoralainaPage from '@/pages/lainat/MoottoripyoralainaPage';
import PienkonelainaPage from '@/pages/lainat/PienkonelainaPage';
import PienlainatLuottokortitPage from '@/pages/lainat/PienlainatLuottokortitPage';
import PikalainaPage from '@/pages/lainat/PikalainaPage';
import RemonttilainaPage from '@/pages/lainat/RemonttilainaPage';
import UlosottoPage from '@/pages/lainat/UlosottoPage';
import VenelainaPage from '@/pages/lainat/VenelainaPage';
import YrityslainaPage from '@/pages/lainat/YrityslainaPage';

// Legal pages
import TietosuojaselostePage from '@/pages/TietosuojaselosteePage';
import KayttoehdotPage from '@/pages/KayttoehdotPage';

// Article pages
import ArtikkelitPage from '@/pages/ArtikkelitPage';
import ArticlePage from '@/pages/artikkelit/ArticlePage';

// Language pages - using standard short codes only
import EnglishPage from '@/pages/EnglishPage';
import SwedishPage from '@/pages/SwedishPage';
import ArabicPage from '@/pages/ArabicPage';
import HebrewPage from '@/pages/HebrewPage';
import EnglishApplyPage from '@/pages/EnglishApplyPage';
import EnglishProductsPage from '@/pages/EnglishProductsPage';
import EnglishInfoPage from '@/pages/EnglishInfoPage';
import EnglishTermsPage from '@/pages/EnglishTermsPage';
import EnglishPrivacyPage from '@/pages/EnglishPrivacyPage';
import SwedishApplyPage from '@/pages/SwedishApplyPage';
import SwedishProductsPage from '@/pages/SwedishProductsPage';
import SwedishInfoPage from '@/pages/SwedishInfoPage';
import SwedishTermsPage from '@/pages/SwedishTermsPage';
import SwedishPrivacyPage from '@/pages/SwedishPrivacyPage';
import ArabicApplyPage from '@/pages/ArabicApplyPage';
import ArabicProductsPage from '@/pages/ArabicInfoPage';
import ArabicInfoPage from '@/pages/ArabicInfoPage';
import ArabicTermsPage from '@/pages/ArabicTermsPage';
import ArabicPrivacyPage from '@/pages/ArabicPrivacyPage';
import HebrewApplyPage from '@/pages/HebrewApplyPage';
import HebrewProductsPage from '@/pages/HebrewInfoPage';
import HebrewInfoPage from '@/pages/HebrewInfoPage';
import HebrewTermsPage from '@/pages/HebrewTermsPage';
import HebrewPrivacyPage from '@/pages/HebrewPrivacyPage';

// Import article pages directly
import LainanOttamisenOpas2025ArticlePage from '@/pages/artikkelit/LainanOttamisenOpas2025ArticlePage';
import YrittajanRahoitusOpas2025ArticlePage from '@/pages/artikkelit/YrittajanRahoitusOpas2025ArticlePage';
import KorkojenNousuArticlePage from '@/pages/artikkelit/KorkojenNousuArticlePage';
import KoronNousunTaituminenArticlePage from '@/pages/artikkelit/KoronNousunTaittuminenArticlePage';
import YhdistelylainaOpasArticlePage from '@/pages/artikkelit/YhdistelylainaOpasArticlePage';
import LainavertailuOpasArticlePage from '@/pages/artikkelit/LainavertailuOpasArticlePage';
import KulutusluottoVertailuArticlePage from '@/pages/artikkelit/KulutusluottoVertailuArticlePage';
import HauskaLomalainaArticlePage from '@/pages/artikkelit/HauskaLomalainaArticlePage';
import VenelainaOpasArticlePage from '@/pages/artikkelit/VenelainaOpasArticlePage';
import LomakohteetArticlePage from '@/pages/artikkelit/LomakohteetArticlePage';
import AsuntomarkkinatEnnuste2025ArticlePage from '@/pages/artikkelit/AsuntomarkkinatEnnuste2025ArticlePage';
import UlosotonAbcArticlePage from '@/pages/artikkelit/UlosotonAbcArticlePage';
import CaravanMatkailuSuomessa2025ArticlePage from '@/pages/artikkelit/CaravanMatkailuSuomessa2025ArticlePage';
import VastuullinenLainaaminenArticlePage from '@/pages/artikkelit/VastuullinenLainaaminenArticlePage';
import KorotKokonaiskustannuksetArticlePage from '@/pages/artikkelit/KorotKokonaiskustannuksetArticlePage';

// Admin page
import AdminPage from '@/pages/AdminPage';

export const MainRoutes = () => {
  console.log("Loading MainRoutes component");
  
  return (
    <Routes>
      {/* 1. MAIN PAGES - Finnish (index route removed as it's handled in AppRoutes) */}
      <Route path="kilpailuta" element={<KilpailutaPage />} />
      <Route path="lainatuotteet" element={<LainatuotteetPage />} />
      <Route path="meista" element={<MeistaPage />} />
      <Route path="yhteystiedot" element={<YhteydenottoPage />} />
      <Route path="ukk" element={<UKKPage />} />
      <Route path="lainalaskuri" element={<LainaLaskuriPage />} />
      <Route path="lainahakemus" element={<SortterPage />} />
      <Route path="hakemus-1" element={<AxoHakemusPage />} />
      <Route path="unsubscribe" element={<UnsubscribePage />} />
      <Route path="lainavertailu" element={<LainavertailuPage />} />
      <Route path="kiitos" element={<ThankYouPage />} />
      <Route path="admin" element={<AdminPage />} />
      
      {/* 3. LOAN PRODUCT PAGES */}
      <Route path="lainat/yhdistelylaina" element={<YhdistelylainaPage />} />
      <Route path="lainat/asuntolaina" element={<AsuntolainaPage />} />
      <Route path="lainat/autolaina" element={<AutolainaPage />} />
      <Route path="lainat/caravanrahoitus" element={<CaravanrahoitusPage />} />
      <Route path="lainat/haalaina" element={<HaalainaPage />} />
      <Route path="lainat/joustoluotto" element={<JoustoluottoPage />} />
      <Route path="lainat/kulutusluotto" element={<KulutusluottoPage />} />
      <Route path="lainat/lomalaina" element={<LomalainaPage />} />
      <Route path="lainat/mokkilaina" element={<MokkilainaPage />} />
      <Route path="lainat/moottoripyoralaina" element={<MoottoripyoralainaPage />} />
      <Route path="lainat/pienkonelaina" element={<PienkonelainaPage />} />
      <Route path="lainat/pienlainat-luottokortit" element={<PienlainatLuottokortitPage />} />
      <Route path="lainat/pikalaina" element={<PikalainaPage />} />
      <Route path="lainat/remonttilaina" element={<RemonttilainaPage />} />
      <Route path="lainat/ulosotto" element={<UlosottoPage />} />
      <Route path="lainat/ulosottolaskuri" element={<LainaLaskuriPage />} />
      <Route path="lainat/venelaina" element={<VenelainaPage />} />
      <Route path="lainat/yrityslaina" element={<YrityslainaPage />} />
      
      {/* 4. LEGAL & INFO PAGES */}
      <Route path="tietosuojaseloste" element={<TietosuojaselostePage />} />
      <Route path="kayttoehdot" element={<KayttoehdotPage />} />
      <Route path="sivustokartta" element={<SivustokarttaPage />} />
      {/* Redirect old sitemap path to new one */}
      <Route path="sitemap" element={<Navigate to="/sivustokartta" replace />} />
      
      {/* 5. LANGUAGE PAGES - Using standard short language codes ONLY */}
      {/* English */}
      <Route path="en" element={<EnglishPage />} />
      <Route path="en/apply" element={<EnglishApplyPage />} />
      <Route path="en/products" element={<EnglishProductsPage />} />
      <Route path="en/info" element={<EnglishInfoPage />} />
      <Route path="en/terms" element={<EnglishTermsPage />} />
      <Route path="en/privacy" element={<EnglishPrivacyPage />} />
      
      {/* Swedish */}
      <Route path="sv" element={<SwedishPage />} />
      <Route path="sv/apply" element={<SwedishApplyPage />} />
      <Route path="sv/products" element={<SwedishProductsPage />} />
      <Route path="sv/info" element={<SwedishInfoPage />} />
      <Route path="sv/terms" element={<SwedishTermsPage />} />
      <Route path="sv/privacy" element={<SwedishPrivacyPage />} />
      
      {/* Arabic */}
      <Route path="ar" element={<ArabicPage />} />
      <Route path="ar/apply" element={<ArabicApplyPage />} />
      <Route path="ar/products" element={<ArabicProductsPage />} />
      <Route path="ar/info" element={<ArabicInfoPage />} />
      <Route path="ar/terms" element={<ArabicTermsPage />} />
      <Route path="ar/privacy" element={<ArabicPrivacyPage />} />
      
      {/* Hebrew */}
      <Route path="he" element={<HebrewPage />} />
      <Route path="he/apply" element={<HebrewApplyPage />} />
      <Route path="he/products" element={<HebrewProductsPage />} />
      <Route path="he/info" element={<HebrewInfoPage />} />
      <Route path="he/terms" element={<HebrewTermsPage />} />
      <Route path="he/privacy" element={<HebrewPrivacyPage />} />
      
      {/* 6. ARTICLE PAGES - These must be BEFORE the generic /:slug route */}
      <Route path="artikkelit" element={<ArtikkelitPage />} />
      
      {/* Specific article routes - THESE MUST COME FIRST */}
      <Route path="artikkelit/vastuullinen-lainaaminen-nain-teet-kestavia-rahoituspaatoksia" element={
        <>
          {console.log("VastuullinenLainaaminenArticlePage route matched!")}
          <VastuullinenLainaaminenArticlePage />
        </>
      } />
      <Route path="artikkelit/caravan-matkailu-suomessa-2025" element={
        <>
          {console.log("CaravanMatkailuSuomessa2025ArticlePage route matched!")}
          <CaravanMatkailuSuomessa2025ArticlePage />
        </>
      } />
      <Route path="artikkelit/lainan-ottamisen-opas-2025" element={<LainanOttamisenOpas2025ArticlePage />} />
      <Route path="artikkelit/yrittajan-rahoitusopas-2025-nain-haet-ja-saat-yrityslainaa" element={<YrittajanRahoitusOpas2025ArticlePage />} />
      <Route path="artikkelit/korkojen-nousu-ja-inflaatio" element={<KorkojenNousuArticlePage />} />
      <Route path="artikkelit/koron-nousun-taittuminen" element={<KoronNousunTaituminenArticlePage />} />
      <Route path="artikkelit/yhdistelylaina-opas-lainojen-yhdistamiseen" element={<YhdistelylainaOpasArticlePage />} />
      <Route path="artikkelit/miten-valita-oikea-laina-eri-tilanteisiin-2025" element={<LainavertailuOpasArticlePage />} />
      <Route path="artikkelit/kulutusluottojen-vertailu-saasta-korkokuluissa" element={<KulutusluottoVertailuArticlePage />} />
      <Route path="artikkelit/hauska-lomalaina-rahoita-unelmalomasi-suomen-parhaisiin-luontokohteisiin" element={<HauskaLomalainaArticlePage />} />
      <Route path="artikkelit/venelainaopas-nain-rahoitat-unelmiesi-veneen" element={<VenelainaOpasArticlePage />} />
      <Route path="artikkelit/suosituimmat-lomakohteet-2025" element={<LomakohteetArticlePage />} />
      <Route path="artikkelit/asuntomarkkinoiden-ennuste-2025-kannattaako-nyt-ostaa-vai-myyda" element={<AsuntomarkkinatEnnuste2025ArticlePage />} />
      <Route path="artikkelit/ulosoton-abc-kaikki-mita-sinun-tulee-tietaa-ulosotosta" element={<UlosotonAbcArticlePage />} />
      <Route path="artikkelit/nain-korot-vaikuttavat-lainan-kokonaiskustannuksiin" element={<KorotKokonaiskustannuksetArticlePage />} />
      
      {/* Generic article route - this should be LAST to catch all other article slugs */}
      <Route path="artikkelit/:slug" element={<ArticlePage />} />
    </Routes>
  );
};

export default MainRoutes;
